
import { ATag } from '../components/ATag';
import { useRegistro } from '../hooks/useRegistroNuevo';
import Escolaridades from '../components/Escolaridades';
import Domicilio from '../components/Domicilio';
import DomicilioFiscal from '../components/DomicilioFiscal';
// import LinkActualizarCV from '../components/LinkActualizarCV';
import { Button, FloatingLabel, Form } from 'react-bootstrap';
import fechaMenos18 from '../functions/fechaMenos18';
import ExperienciaDocente from '../components/ExperienciaDocente';
import ExperienciaSectorProductivo from '../components/ExperienciaSectorProductivo';
import Lentes from '../components/Lentes';
import HijosComponent from '../components/Hijos';
import Estudiando from '../components/Estudiando';
import Problema from '../components/Problema';
import { Toaster } from 'react-hot-toast';
import useRegistroNombre from '../hooks/useRegistroNombre';
import FlexCenter from '../components/FlexCenter';
import ContactosEmergencia from '../components/ContactosEmergencia';
import Archivo from '../components/Archivo';
import CardContenedor from '../components/CardContenedor';
import { Volver } from '../components/Volver';
import TerminosCondiciones from '../components/TerminosCondiciones';
import { useEmpleadoStore } from '../stores/useEmpleadoStore';
import CuentaBancaria from '../components/CuentaBancaria';


export const Registro = () => {
  // eslint-disable-next-line
  const {
    formDatosInicial, setFormDatosInicial, cargandoGenerales, guardarDatosGenerales
  } = useRegistro();

  const { cargando, editarNombre, formNombres, setFormNombres } = useRegistroNombre()
  const aceptado = useEmpleadoStore(state => state.aceptado)

  return (
    <CardContenedor>

      <Volver />

      <div className="row mt-4">
        {/* nombre */}
        <div className="col-12 col-md-6">
          <FloatingLabel label="Nombre" className="mb-3">
            <Form.Control placeholder=" " value={formNombres.nombre} onChange={e => setFormNombres({ ...formNombres, nombre: e.target.value })} />
          </FloatingLabel>
        </div>

        {/* apellidos */}
        <div className="col-12 col-md-6">
          <FloatingLabel label="Apellidos" className="mb-3">
            <Form.Control placeholder=" " value={formNombres.apellido} onChange={e => setFormNombres({ ...formNombres, apellido: e.target.value })} />
          </FloatingLabel>
        </div>

        {/* btn guardar nombres */}
        <div className='col-12 mb-3'>
          <FlexCenter>
            <Button onClick={editarNombre} disabled={cargando}>
              {(cargando) ? "Guardando" : "Guardar cambios"}
            </Button>
          </FlexCenter>
        </div>


        <TerminosCondiciones />


        {
          !aceptado
            ? <p className='lead mt-5 text-center'>Para continuar, debes aceptar el aviso de privacidad</p>
            :
            <>
              <Escolaridades />

              <p className="lead text-center">
                Información general
              </p>

              <div className='ml-3'>
                <ATag link="https://www.gob.mx/curp/" texto="Consultar CURP" />
                <ATag link="https://serviciosdigitales.imss.gob.mx/gestionAsegurados-web-externo/asignacionNSS" texto="Consultar NSS" />
              </div>

              {/* fecha_ingreso */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Fecha de ingreso a la UTESC" className="mb-3">
                  <Form.Control type="date" placeholder=" " value={formDatosInicial.fecha_ingreso} onChange={e => setFormDatosInicial({ ...formDatosInicial, fecha_ingreso: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* rfc */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="RFC (13 dígitos)" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.rfc} onChange={e => setFormDatosInicial({ ...formDatosInicial, rfc: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* nss */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="NSS (11 dígitos)" className="mb-3">
                  <Form.Control type="number" placeholder=" " value={formDatosInicial.nss} onChange={e => {
                    if (e.target.value?.length <= 11) setFormDatosInicial({ ...formDatosInicial, nss: e.target.value })
                  }} />
                </FloatingLabel>
              </div>

              <div className="col-12 col-md-6">
                <FloatingLabel label="CURP" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.curp} onChange={e => {
                    if (e.target.value?.length <= 18) setFormDatosInicial({ ...formDatosInicial, curp: e.target.value })
                  }} />
                </FloatingLabel>
              </div>

              {/* fnac */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Fecha de nacimiento" className="mb-3">
                  <Form.Control type="date" placeholder=" " value={formDatosInicial.fnac} onChange={e => setFormDatosInicial({ ...formDatosInicial, fnac: e.target.value })} max={fechaMenos18()} />
                </FloatingLabel>
              </div>

              {/* edad */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Edad" className="mb-3">
                  <Form.Control type="number" placeholder=" " value={formDatosInicial.edad} readOnly />
                </FloatingLabel>
              </div>

              {/* nacionalidad */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Nacionalidad" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.nacionalidad} onChange={e => setFormDatosInicial({ ...formDatosInicial, nacionalidad: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* estado civil */}
              <div className="col-12 col-md-6">
                <div className="form-floating mb-3">
                  <FloatingLabel label="Estado civil" >
                    <Form.Select aria-label=" " value={formDatosInicial.estado_civil} onChange={e => setFormDatosInicial({ ...formDatosInicial, estado_civil: e.target.value })}>
                      <option value="0">
                        Seleccione una opción
                      </option>
                      <option value="Soltera(o)">Soltera(o)</option>
                      <option value="Casada(o)">Casada(o)</option>
                      <option value="Unión libre">Unión libre</option>
                    </Form.Select>
                  </FloatingLabel>
                </div>
              </div>

              {/* sexo */}
              <div className="col-12 col-md-6">
                <div className="form-floating mb-3">
                  <FloatingLabel label="Sexo" >
                    <Form.Select aria-label=" " value={formDatosInicial.sexo} onChange={e => setFormDatosInicial({ ...formDatosInicial, sexo: e.target.value })}>
                      <option value="0">
                        Seleccione una opción
                      </option>
                      <option value="Masculino">Masculino</option>
                      <option value="Femenino">Femenino</option>
                      <option value="Intersex">Intersex</option>
                    </Form.Select>
                  </FloatingLabel>
                </div>
              </div>

              {/* telefono */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Teléfono particular" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.tel} onChange={e => setFormDatosInicial({ ...formDatosInicial, tel: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* celular */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Celular" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.cel} onChange={e => setFormDatosInicial({ ...formDatosInicial, cel: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* correo personal */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Correo personal" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.email_personal} onChange={e => setFormDatosInicial({ ...formDatosInicial, email_personal: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* lugar de nacimiento */}
              <div className="col-12 col-md-6">
                <FloatingLabel label="Lugar de nacimiento" className="mb-3">
                  <Form.Control placeholder=" " value={formDatosInicial.lugar_de_nacimiento} onChange={e => setFormDatosInicial({ ...formDatosInicial, lugar_de_nacimiento: e.target.value })} />
                </FloatingLabel>
              </div>

              {/* btn guardar nombres */}
              <div className='col-12 mt-3'>
                <FlexCenter>
                  <Button onClick={guardarDatosGenerales} disabled={cargandoGenerales}>
                    {(cargandoGenerales) ? "Guardando" : "Guardar cambios"}
                  </Button>
                </FlexCenter>
              </div>

              <Archivo />

              <ContactosEmergencia />

              {/* domicilio */}
              <Domicilio />
              <ExperienciaDocente />
              <ExperienciaSectorProductivo />

              {/* domicilio fiscal */}
              <DomicilioFiscal />
              <Lentes />
              <HijosComponent />
              <Estudiando />
              <Problema />
              <CuentaBancaria />
            </>
        }






      </div>
      <Toaster />
    </CardContenedor>
  );
};
